import {initialState} from "../../../../reduxStore";
import {
    BACKGROUND_MESSAGE_TYPE,
    BUILD_STATUS,
    DASHBOARD_EXPORT_OPTIONS,
    DOWNLOAD_DOCUMENT_TYPE,
    POLLING_TIMEOUT
} from "../../../../constants";
import utils from "../../../../utils/utilities";
import deliveryUtils from "../../../../utils/deliveryUtils";
import api from "../../../../api/Common.api";

let dateFormat = require('dateformat');

const ExportDashboardController = {
    exportDashboard(exportOption, fileName, filtersState) {
        let payload = this.getDashboardExportPayload(exportOption, fileName, filtersState);
        this.handleDashboardExport(payload);
    },

    getDashboardExportPayload(exportOption, fileName, filtersState) {
        let initialFiltersState = initialState.user.preferences.filters;
        let {entities, risk, pestle, days, language} = filtersState;

        if (exportOption === DASHBOARD_EXPORT_OPTIONS.ALL_DATA) {
            let riskObject = {...initialFiltersState["riskFilter"]};
            Object.keys(riskObject)
                .forEach(option => riskObject[option] = true);
            risk = riskObject;

            entities = initialFiltersState.entitiesFilter;
            pestle = initialFiltersState.pestleFilter;
            days = initialFiltersState.daysFilter;
            language = initialFiltersState.languageFilter;
        }

        let dashboardFilters = utils.buildDashboardFilter(entities, risk, pestle, days, language);
        let date = new Date();
        let uiDate = dateFormat(date, "dd mmm yyyy");
        let uiTime = dateFormat(date, "HH:MM");

        return {
            documentType: DOWNLOAD_DOCUMENT_TYPE.DASHBOARD,
            filename: fileName,
            metadata: {
                uiDate,
                uiTime,
                dashboardFilter: dashboardFilters
            }
        };
    },

    handleDashboardExport(payload) {
        deliveryUtils.dispatchProcessingMessage({
            title: "Dashboard_CoreFunctionality_UIText_Deliveries.exportInProgress",
            shrink: true,
            type: BACKGROUND_MESSAGE_TYPE.PROCESSING,
        });

        return api.createDelivery(payload)
            .then(response => {
                this.getDashboardExportDataStatus(response.id, response.filename);
            })
            .catch(() => {
                deliveryUtils.dispatchErrorMessage({
                    title: "Dashboard_CoreFunctionality_UIText_Deliveries.downloadFail.title",
                    message: "Dashboard_CoreFunctionality_UIText_Deliveries.downloadFail.description",
                    type: BACKGROUND_MESSAGE_TYPE.ERROR,
                });
            });
    },

    getDashboardExportDataStatus(id, fileName) {
        let intervalTimeId = setInterval(() => {
            api.getDeliveryStatus(id)
                .then(buildStatus => {
                    switch (buildStatus) {
                        case BUILD_STATUS.FINISHED:
                            clearInterval(intervalTimeId);
                            this.downloadDashboardExportData(id, fileName);
                            break;
                        case BUILD_STATUS.STARTED:
                        case BUILD_STATUS.PROCESSING:
                            deliveryUtils.dispatchProcessingMessage({
                                title: "Dashboard_CoreFunctionality_UIText_Deliveries.exportInProgress",
                                shrink: true,
                                type: BACKGROUND_MESSAGE_TYPE.PROCESSING,
                            });
                            break;
                        case BUILD_STATUS.ERROR:
                            clearInterval(intervalTimeId);
                            deliveryUtils.dispatchErrorMessage({
                                title: "Dashboard_CoreFunctionality_UIText_Deliveries.downloadFail.title",
                                message: "Dashboard_CoreFunctionality_UIText_Deliveries.downloadFail.description",
                                type: BACKGROUND_MESSAGE_TYPE.ERROR,
                            });
                            break;
                    }
                })
                .catch(err => {
                    console.log(err);
                    clearInterval(intervalTimeId);
                    deliveryUtils.dispatchErrorMessage({
                        title: "Dashboard_CoreFunctionality_UIText_Deliveries.downloadFail.title",
                        message: "Dashboard_CoreFunctionality_UIText_Deliveries.downloadFail.description",
                        type: BACKGROUND_MESSAGE_TYPE.ERROR,
                    });
                });
        }, POLLING_TIMEOUT);
    },

    downloadDashboardExportData(id, fileName) {
        api.downloadDelivery(id)
            .then(() => {
                deliveryUtils.dispatchSuccessMessage({
                    title: "Dashboard_CoreFunctionality_UIText_Deliveries.downloadReady",
                    messageParameters: fileName,
                    type: BACKGROUND_MESSAGE_TYPE.DOWNLOAD,
                    isVisible: true,
                    link:    `/api/delivery/${id}/download`,
                    //DO NOT COMMIT LINE, local env only
                    // link: `http://localhost:8080/api/delivery/${id}/download`,
                });
            })
            .catch(err => {
                console.log(err);
                deliveryUtils.dispatchErrorMessage({
                    title: "Dashboard_CoreFunctionality_UIText_Deliveries.downloadFail.title",
                    message: "Dashboard_CoreFunctionality_UIText_Deliveries.downloadFail.description",
                    type: BACKGROUND_MESSAGE_TYPE.ERROR,
                });
            })
    }
};

export default ExportDashboardController;


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/ExportDashboardController.js